import { APP_CONFIG } from './app.config';

const API_BASE = `${APP_CONFIG.apiBaseUrl}`;

export const API_ENDPOINT = {
  AUTH: {
    LOGIN: `${API_BASE}/authentication/login`,
    REFRESH: `${API_BASE}/authentication/token/refresh`,
    SKIP_LOGIN: `${API_BASE}/authentication/skip-login-by-ckpass-token`,
    LOGOUT: `${API_BASE}/authentication/logout`,
    ME: `${API_BASE}/authentication/me`,
  },
  USERS: {
    LIST: `${API_BASE}/users`,
    DETAIL: (id: string) => `${API_BASE}/users/${encodeURIComponent(id)}`,
  },
  USER: {
    GET: `${API_BASE}/user/get`,
    GET_BY_ID: (userId: string) => `${API_BASE}/user/get/${encodeURIComponent(userId)}`,
    UPDATE: `${API_BASE}/user/update`,
    UPDATE_BY_ADMIN: (userId: string) => `${API_BASE}/user/update/${encodeURIComponent(userId)}`,
    GET_ALL: `${API_BASE}/user/get-all`,
    STAFFS: `${API_BASE}/user/staffs`,
    ADD_MODULE: `${API_BASE}/user/add-module`,
  },
  ADMIN_INVITE: {
    CREATE: `${API_BASE}/admin/invite`,
    LIST: `${API_BASE}/admin/invite/list`,
    REVOKE: `${API_BASE}/admin/invite/revoke`,
  },
  LOCATION: {
    CREATE: `${API_BASE}/location/create`,
    GET_ALL: `${API_BASE}/location/get-all`,
    GET_ALL_ADMIN: `${API_BASE}/location/get-all-admin`,
    GET: (id: string) => `${API_BASE}/location/get/${encodeURIComponent(id)}`,
    GET_ADMIN: (id: string) => `${API_BASE}/location/get-admin/${encodeURIComponent(id)}`,
    UPDATE: `${API_BASE}/location/update`,
    BULK_STATUS_UPDATE: `${API_BASE}/location/bulk-status-update`,
    PICTURE_UPLOAD_URL: `${API_BASE}/location/picture-upload-url`,
    PICTURE_UPDATE: `${API_BASE}/location/picture-update`,
  },
  SLOT: {
    CALENDAR: `${API_BASE}/slot/calendar`,
    CONFIG_SET: `${API_BASE}/slot/admin/config`,
    CONFIG_LIST: `${API_BASE}/slot/admin/config/get-all`,
    CONFIG_UPDATE: `${API_BASE}/slot/admin/config/update`,
  },
  BOOKING_RULE: {
    GET: `${API_BASE}/booking-rule/get`,
    UPDATE: `${API_BASE}/booking-rule/update`,
  },
  BOOKING: {
    REGISTER: `${API_BASE}/booking/register`,
    GET_MINE: `${API_BASE}/booking/get-mine`,
    CANCEL: `${API_BASE}/booking/cancel`,
    GET_BOOKING: `${API_BASE}/booking/get-booking`,
    GET_ALL: `${API_BASE}/booking/get-all`,
    EXPORT: `${API_BASE}/booking/export`,
    ADMIN_REGISTER: `${API_BASE}/booking/admin/register`,
    CALENDAR: `${API_BASE}/booking/calendar`,
    ADMIN_UPDATE: `${API_BASE}/booking/admin/update`,
    LOGS: `${API_BASE}/booking/logs`,
  },
  BOOKINGS: {
    LIST: `${API_BASE}/bookings`,
    CREATE: `${API_BASE}/bookings`,
    DETAIL: (id: string) => `${API_BASE}/bookings/${encodeURIComponent(id)}`,
  },
  DASHBOARD: {
    SUMMARY: `${API_BASE}/dashboard/summary`,
  },
  NEWS: {
    CREATE: `${API_BASE}/news/create`,
    GET_ALL: `${API_BASE}/news/get-all`,
    GET_NEWS: (newsId: string) => `${API_BASE}/news/get-news/${encodeURIComponent(newsId)}`,
    UPDATE: `${API_BASE}/news/update`,
  },
  INQUIRY: {
    CREATE: `${API_BASE}/inquiry/create`,
    GET_ALL: `${API_BASE}/inquiry/get-all`,
    GET: (inquiryId: string) => `${API_BASE}/inquiry/get/${encodeURIComponent(inquiryId)}`,
    UPDATE: `${API_BASE}/inquiry/update`,
  },
} as const;
